import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const Mena = {
	name: NAME,
	apiProvider,
	router,
};
